/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationDto
 */
export interface ConfigurationDto {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    configurationType?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    scope?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigurationDto
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConfigurationDto
     */
    configurationData?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConfigurationDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationDto
     */
    updatedBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ConfigurationDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ConfigurationDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigurationDto
     */
    _default?: boolean;
}

/**
 * Check if a given object implements the ConfigurationDto interface.
 */
export function instanceOfConfigurationDto(value: object): value is ConfigurationDto {
    return true;
}

export function ConfigurationDtoFromJSON(json: any): ConfigurationDto {
    return ConfigurationDtoFromJSONTyped(json, false);
}

export function ConfigurationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'configurationType': json['configurationType'] == null ? undefined : json['configurationType'],
        'scope': json['scope'] == null ? undefined : json['scope'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'version': json['version'] == null ? undefined : json['version'],
        'configurationData': json['configurationData'] == null ? undefined : json['configurationData'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'active': json['active'] == null ? undefined : json['active'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        '_default': json['default'] == null ? undefined : json['default'],
    };
}

export function ConfigurationDtoToJSON(json: any): ConfigurationDto {
    return ConfigurationDtoToJSONTyped(json, false);
}

export function ConfigurationDtoToJSONTyped(value?: ConfigurationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'configurationType': value['configurationType'],
        'scope': value['scope'],
        'tenantId': value['tenantId'],
        'name': value['name'],
        'description': value['description'],
        'version': value['version'],
        'configurationData': value['configurationData'],
        'metadata': value['metadata'],
        'active': value['active'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'default': value['_default'],
    };
}

